import { Navbar } from "./navbar"
import { HeroSection } from "./hero-section"
import { AboutSection } from "./about-section"

import { ContactSection } from "./contact-section"
import { Footer } from "./footer"

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <div className="">
        <HeroSection />
        <AboutSection />
       
        <ContactSection />
      </div>
      <Footer />
    </main>
  )
}

